// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__38Uql","checkboxCol":"Table_checkboxCol__2nBfq","emailCol":"Table_emailCol__3bFXH","actionCol":"Table_actionCol__1iQ3s"};